import config from '@/config';
import { fetchData } from '@/model/utils/fetch';

export const fetchBonusPermission = async ({
  authToken,
  jurisdiction,
}: {
  authToken: string;
  jurisdiction: string;
}) => {
  try {
    const res = await fetchData<{
      [key: string]: any;
    }>({
      url: `${config.urls.bffBaseUrl}/bonus-permission`,
      headers: { authorization: `Bearer ${authToken}` },
      queryParameters: {
        jurisdiction,
      },
    });

    return {
      status: 200,
      data: res,
    };
  } catch (err) {
    console.error(
      `There was a problem while fetching Bonus permission data. ${config.urls.bffBaseUrl}/bonus-permission`
    );
    console.error(err);

    return {
      // @ts-ignore
      status: err.status,
      data: {},
    };
  }
};
